import { AnyPeriod, castPeriod, toGQLDate } from "@ct-react/core";

type OpenArticleParams = {
  id?: string;
  bookingPeriod?: AnyPeriod;
}

export const parse = (params: URLSearchParams): OpenArticleParams => {

  const start = params.get("b_in");
  const end = params.get("b_out");

  return {
    ...(params.has("refId")) && { id: params.get("refId")! },
    ...(!!start && !!end) && { bookingPeriod: [ start, end ] }
  };

}

export const rebuild = (period?: AnyPeriod, params: URLSearchParams = new URLSearchParams()): URLSearchParams => {

  params.delete("b_in");
  params.delete("b_out");

  if (!!period) {
    const casted = castPeriod(period);
    params.set("b_in", toGQLDate(casted.start));
    params.set("b_out", toGQLDate(casted.end));
  }

  return params;

}
